module.exports = {"id":"163301","name":"Jonathan Orozco","rating":"75","photo":"./data/images/photos/1/163301.png","club":{"name":"Santos Laguna","logo":"./data/images/clubs/SantosLaguna.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JonathanOrozco0.json
// module id = 2105
// module chunks = 0